const rankings = [
  { rank: 1, title: '顶流男星夜会神秘女', heat: '1,287万', trend: 'up', change: '+3' },
  { rank: 2, title: '颁奖礼内定丑闻持续发酵', heat: '1,156万', trend: 'up', change: '+5' },
  { rank: 3, title: '暑期档票房争霸白热化', heat: '1,023万', trend: 'down', change: '-1' },
  { rank: 4, title: '新晋流量小生成绩单亮眼', heat: '892万', trend: 'up', change: '+2' },
  { rank: 5, title: '知名导演新作预告刷屏', heat: '765万', trend: 'new', change: 'NEW' },
  { rank: 6, title: '音乐节豪华阵容全曝光', heat: '698万', trend: 'down', change: '-2' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          热搜榜单
        </h2>
        <div className="max-w-2xl mx-auto">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 py-4 border-b border-background-200 last:border-0 group cursor-pointer transition-colors hover:bg-background-50 px-4 rounded-lg"
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-foreground-950' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                <span className="text-sm font-heading">{item.rank}</span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">{item.title}</h3>
              </div>
              <div className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</div>
              <div className={`text-xs font-medium whitespace-nowrap ${
                item.trend === 'up' ? 'text-primary-500' :
                item.trend === 'new' ? 'text-accent-500' :
                'text-foreground-400'
              }`}>
                {item.change}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}